import { SAVE_BACK_URL } from 'constants/actionTypes';

export const saveBackUrlReducer = (state = '', action) => {
    switch(action.type) {
        case SAVE_BACK_URL:
            return action.payload;
        default:
            return state;
    }
};
